import React from "react";
import Aos from "aos";
import "../Style/about.css";
const About = () => {
  React.useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <section id="about">
      <div
        id="tech"
        data-aos="fade-down-right"
        data-aos-duration="1500"
        data-aos-delay="100"
      >
        <h1 style={{ color: "var(--color-font)" }}>About Me</h1>
      </div>

      <div id="aboutdiv">
        <div
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1500"
          data-aos-offset="70"
        >
          <ul type="square">
            <h2>The Best Way To Learn Something Is To Build Something.</h2>
            <li>
              {" "}
              An enthusiastic Full Stack Web Developer skilled in MERN stack
              with 1300+ hours of experience in coding. Knowledge of HTML, CSS,
              Javascript, React, Redux, Next.js, Node.js, Express.js and
              MongoDB. High adaptability to learn new technologies quickly and
              paying attention to details. Looking to start a career as a web
              developer with a reputed firm driven by technology.
            </li>
          </ul>
        </div>
        <div
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1500"
          data-aos-offset="70"
        >
          <img
            src="https://img.freepik.com/premium-vector/man-working-home_28923-46.jpg?w=740"
            alt=""
          />
        </div>
      </div>
    </section>
  );
};

export default About;
